import {getMethod} from '~/api'

async function get(productTypeName) {
    return await getMethod(`/api/ownProductType/${productTypeName}/secondaryService`)
}

export {get}
